import React from 'react';

import styles from './ratingDisplayV3.scss';

const PBRScale = ({ value, lightBg }) => {
    const values = ['R1', 'O1', 'O2', 'G1', 'G2', 'G3'];
    return (
        <div className={`${styles.pbrScale} ${lightBg ? styles.lightBg : ''}`}>
            {values.map((val, i) => (
                <div className={`${styles.segment}`}>
                    <div className={`${styles.color} ${styles[val[0]]} ${i <= values.indexOf(value) ? styles.active : ''}`} />
                    <div className={`${styles.label} ${i === values.indexOf(value) ? styles.active : ''}`}>
                        {val}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PBRScale;
